import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit {
  menus: any[] = [
    {
      icon: 'assets/sidebar/overview-active.svg',
      icon2: 'assets/sidebar/overview-inactive.svg',
      name: 'Overview',
      route: '/app/dashboard/overview',
      hasChild: false,
    },
    {
      icon: 'assets/sidebar/product-inactive.svg',
      icon2: 'assets/sidebar/product-inactive.svg',
      name: 'Products',
      route: '/app/dashboard/products',
      hasChild: false,
    },
    {
      icon: 'assets/sidebar/orders-active.svg',
      icon2: 'assets/sidebar/orders-inactive.svg',
      name: 'Orders',
      route: '/app/dashboard/orders',
      hasChild: false,
    },
    {
      icon: 'assets/sidebar/product-inactive.svg',
      icon2: 'assets/sidebar/product-inactive.svg',
      name: 'Category',
      route: '/app/dashboard/category',
      hasChild: false,
    },
    {
      icon: 'assets/sidebar/wallet-inactive.svg',
      icon2: 'assets/sidebar/wallet-inactive.svg',
      name: 'Wallet',
      route: '/app/dashboard/wallet',
      hasChild: false,
    },
    {
      icon: 'assets/sidebar/management-inactive.svg',
      icon2: 'assets/sidebar/management-inactive.svg',
      name: 'Management',
      route: '/app/dashboard/management',
      hasChild: true,
      childArray: [
        { name: 'Branch', route: '/app/dashboard/management/branch' },
        { name: 'Teller', route: 'app/dashboard/management/teller' },
      ],
    },
    {
      icon: 'assets/sidebar/settings-inactive.svg',
      icon2: 'assets/sidebar/settings-inactive.svg',
      name: 'Settings',
      route: '/app/dashboard/settings',
      hasChild: false,
    },
  ];
  showChildNav = false;
  currentUrl: string = '';

  constructor() { }

  ngOnInit() {
    
  }

  toggleChildNav() {
    this.showChildNav = !this.showChildNav;
  }

}
